import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg ${
        size === 'large' ? 'aspect-[2/3]' : 'aspect-[3/4]'
      }`}>
        <img
          src={movie.coverImage}
          alt={movie.title}
          title={`${movie.title} - 51影院免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <p className="text-white text-xs leading-relaxed line-clamp-3">{movie.description}</p>
        </div>
        {movie.rating > 0 && (
          <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
            {movie.rating}
          </div>
        )}
        {movie.updateInfo.includes('更新') && (
          <div className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-1 rounded-md font-medium">
            更新中
          </div>
        )}
      </div>
      <div className="mt-3">
        <h3 className="text-foreground-900 font-medium text-sm md:text-base line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
          <span>{movie.subCategory}</span>
        </div>
      </div>
    </Link>
  );
}